export default function (element, data) {
    let dropBlock = element.querySelector('.filter__block_drop');
    
    element.addEventListener('click', function(){
        dropBlock.classList.toggle('open');
    });

    element.addEventListener("click", function (event) {
        event.stopPropagation();
    });

    document.addEventListener('click', function(event) {
        dropBlock.classList.remove('open');
    });
}
